import clsx from 'clsx'
import PropTypes from 'prop-types'
import Button from '../../../../components/tailwind/Button'

export default function CtaMessage({ description, cta, className }) {
  return (
    <div
      className={clsx(
        'w-full max-w-md rounded-lg border border-lightGrey bg-[#F7F9FE] p-4',
        className
      )}
    >
      {description && (
        <p className='text-base font-normal text-darkBlack'>{description}</p>
      )}

      {cta && (
        <div className='mt-4'>
          <Button.PrimaryBase
            text={cta.text}
            onClick={cta.action}
            className='w-full'
          />
        </div>
      )}
    </div>
  )
}

CtaMessage.propTypes = {
  description: PropTypes.string,
  cta: PropTypes.shape({
    text: PropTypes.string.isRequired,
    action: PropTypes.func.isRequired
  }),
  className: PropTypes.string
}
